export default __webpack_public_path__ + "static/3-daa4a658837f83dc19f8288d946390c2.jpeg";